var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFishPlus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 39,
    viewBox: "0 0 84 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M83.2225 4.574V7.226H78.8285V11.62H76.1765V7.226H71.7825V4.574H76.1765V0.179999H78.8285V4.574H83.2225Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.7069 24.5371C59.195 41.3406 24.956 44.0809 9.22782 29.7012L4.00555 34.1766C3.53536 34.5798 2.80395 34.4361 2.5265 33.886L0.061739 29C-0.0013261 28.8766 -0.0158796 28.7354 0.0173322 28.6045C0.0369234 28.5281 0.0779717 28.4584 0.131708 28.3996L4.59011 23.5269L4.60466 23.5386C4.60373 23.5311 4.60373 23.5227 4.60373 23.5151L4.59011 23.5269L0.131708 18.654C0.0779717 18.5952 0.0369234 18.5254 0.0173322 18.449C-0.0158796 18.318 -0.00151268 18.1779 0.061739 18.0536L2.5265 13.1674C2.80395 12.6173 3.53536 12.4737 4.00555 12.8768L9.19797 17.327C24.9126 2.91535 59.1881 5.64834 69.7069 22.4627C70.0978 23.0875 70.0978 23.9114 69.7069 24.5371Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.103 21.978C55.9275 21.978 57.4065 20.5226 57.4065 18.7272C57.4065 16.9319 55.9275 15.4765 54.103 15.4765C52.2786 15.4765 50.7996 16.9319 50.7996 18.7272C50.7996 20.5226 52.2786 21.978 54.103 21.978Z",
    fill: "#2673B0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 31,
    fill: "white",
    transform: "translate(0 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFishPlus);
export default __webpack_public_path__ + "static/media/fishPlus.ffed6910b5af499c5cdee126c1991725.svg";
export { ForwardRef as ReactComponent };